<template>
  <figure class="ls-image" test-id="image" @click="openImage">
    <div class="img-wrapper">
      <img :src="thumbSrc ? thumbSrc : src" />
      <LsIcon v-if="showResize" type="resize" class="img-resize" />
    </div>
    <figcaption v-if="caption">{{ caption }}</figcaption>
  </figure>
</template>

<script>
import VueTypes from 'vue-types';
import { lsModalService } from 'ls-vue-common';
import LsIcon from '../LsIcon/LsIcon.vue';

export default {
  name: 'LsImage',
  components: { LsIcon },
  props: {
    src: VueTypes.string,
    thumbSrc: VueTypes.string.isRequired,
    caption: VueTypes.string,
    showResize: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openImage() {
      lsModalService.open({
        parent: this,
        content: `<p class="image"><img src="${this.src}"></p>`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-image {
  max-width: 100px;
  cursor: pointer;
  .img-wrapper {
    max-height: 100px;
    max-width: 100px;
    position: relative;
  }
  figcaption {
    font-weight: 700;
    font-size: 14px;
    color: $theme-color-grey-darker;
    margin-top: 0.5rem;
  }
  .img-resize {
    background: #f1f1f1;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>
